import React from 'react';
import { createRoot } from 'react-dom/client';
import { addGAPIMetaHeader } from 'utils/add-gapi-meta-header';
import { initSentry } from 'utils/sentry';
import './root-styles/styles';
import App from './App';
import './typings/type-defs.js';

initSentry();

addGAPIMetaHeader();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(<App />);

window.cms_version = process.env.REACT_APP_VERSION;
